import { Flex, FlexProps, UnstyledButton } from '@mantine/core';
import type { ComponentProps } from 'react';
import styled from 'styled-components';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';

const PlainUnstyledButton = asPlainComponent<ComponentProps<typeof UnstyledButton>>(UnstyledButton);

export const StatusTriggerButton = styled(PlainUnstyledButton)`
	width: 100%;
`;

export const CaretContainer = styled(Flex).attrs<FlexProps & { $isActive: boolean }>(
	(): Partial<FlexProps> => ({
		align: 'center',
		justify: 'center',
		w: 24,
		h: 24,
		p: 4,
	})
)`
	border-radius: 4px;
	background-color: ${({ theme, $isActive }) =>
		$isActive ? theme.v3.colors.gray[2] : 'transparent'};

	&:hover {
		background-color: ${({ theme }) => theme.v3.colors.gray[2]};
	}
`;

export const StatusDropdownContainer = styled.div<{ $openUp: boolean }>`
	position: fixed;
	background: ${({ theme }) => theme.v3.colors.white[0]};
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 6px;
	box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
	z-index: 400;
	overflow: hidden;
	transform: ${({ $openUp }) => ($openUp ? 'translateY(-100%)' : 'none')};
`;

export const StatusDropdownHeader = styled.div`
	padding: 10px 12px;
	border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
`;

export const StatusDropdownItem = styled.div`
	padding: 10px 12px;
	cursor: pointer;
	background: ${({ theme }) => theme.v3.colors.white[0]};

	&:hover {
		background: ${({ theme }) => theme.v3.colors.gray[0]};
	}
`;
